export enum ScannerActionType {
  AddCounterIndex = 'add-counter-index',
  CreateIntervention = 'create-intervention',
  FindDocuments = 'find-documents',
  FindInterventions = 'find-interventions',
  FindTasks = 'find-tasks',
}
